import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import api from '../../services/api';
import { getMediaUrl } from '../../services/api';
import './SliderSection.css';

const SliderSection = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSlides();
  }, []);

  const loadSlides = async () => {
    try {
      const response = await api.get('/sliders/');
      setSlides(response.data);
    } catch (error) {
      console.error('Error loading slides:', error);
    } finally {
      setLoading(false);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    pauseOnHover: true,
    arrows: true,
  };

  // Show default slide if no slides loaded
  if (loading || slides.length === 0) {
    return (
      <section className="slider-section">
        <div className="slide-item">
          <div 
            className="slide-content" 
            style={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}
          >
            <div className="slide-overlay">
              <div className="container">
                <div className="slide-text">
                  <h2>Welcome to Muzaffarpur Municipal Corporation</h2>
                  <p>Building a Smart and Sustainable City</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="slider-section">
      <Slider {...settings}>
        {slides.map(slide => (
          <div key={slide.id}>
            <div className="slide-item">
              <div 
                className="slide-content" 
                style={{ 
                  backgroundImage: slide.image 
                    ? `url(${getMediaUrl(slide.image)})` 
                    : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                }}
              >
                <div className="slide-overlay">
                  <div className="container">
                    <div className="slide-text">
                      <h2>{slide.title}</h2>
                      {slide.subtitle && <p>{slide.subtitle}</p>}
                      {slide.link_url && slide.link_text && (
                        <a href={slide.link_url} className="btn btn-light btn-lg">
                          {slide.link_text}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default SliderSection;
